import { object, ref, string } from 'yup';

export const signUpSchema = object().shape({
  name: string()
    .max(30, 'Must be 30 characters or less')
    .required('Please enter your full name'),
  username: string()
    .max(30, 'Must be 30 characters or less')
    .required('Please enter a username'),
  displayName: string()
    .max(30, 'Must be 30 characters or less')
    .required('Please enter a display name'),
  email: string()
    .email('Invalid email address')
    .required('Please enter an email address'),
  password: string()
    .min(8, 'Password must be at least 8 characters long')
    .required('Please enter a password'),
  passwordVerification: string()
    .oneOf([ref('password'), null], 'Passwords must match')
    .min(8, 'Password must be at least 8 characters long'),
  phone: string().matches(
    /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
    'Invalid phone number'
  ),
  accountType: string()
    .oneOf(['fan', 'artist'])
    .required('Please select an account type'),
  region: string().oneOf(['US', 'CA']),
  birthday: string().required('Please enter your birthday'),
});
